export const iconPosition = (type) => {
  const iconsPosition = {
    home: '-410px -20px',
    bookings: '-442px -20px',
    account: '-474px -20px',
    location: '-870px -6px',
    back: '-0 -20px',
    success: '-1558px -22px',
    bookingImage: '36px -122px',
    locationPointer: '-962px -20px',
    locationPointerSmall: '-934px -24px',
    edit: '-1102px -20px',
    closeIcon: '-38px -20px',
    logoutIcon: '-1078px -24px',
    greenTick: '-1214px -22px',
    deleteIcon: '-978px -184px',
    deleteIconRed: '-1622px -24px',
    minusIcon: '-874px -184px',
    plusIcon: '-912px -186px',
    doubleArrowRight: '-992px -20px',
    share: '-1044px -184px',
    failure: '-1588px -22px',
    instagramIcon: '-1428px -12px',
    calenderIcon: '-720px -20px',
    telephoneIcon: '-1114px -182px',
    chevronDownIcon: '-788px -20px',
    reloadIcon: '-1016px -20px',
    offerIcon: '-1196px -10px',
    minusIconWhite: '-1904px -186px',
    plusIconWhite: '-1936px -186px',
    clockIcon: '-810px -186px',
    instantIcon: '-1972px -186px',
    bookingCompletedIcon: '-52px -319px',
    bookingInProgressIcon: '0 -320px',
    bookingFailedIcon: '-125px -311px',
    billIcon: '-103px -326px',
  };
  return iconsPosition[type];
};
